import { getBuyerIdFromCurrentOrder, getOrderDetails } from '@app/ducks';
import { compiledPaths } from '@app/paths';
import { useBuyerHomepage } from '@app/services/hooks/pages/useBuyerHomepage';
import { isDefined } from '@app/utils/is';
import { isEmpty } from '@app/utils/isEmpty';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

import { SkeletonLayout } from '../various/SkeletonLayout';
import { PageSkeleton } from '../various/SkeletonLayout/layouts/PageSkeleton';
import { Wrapper, WrapperSize } from '../various/Wrapper';

export const Home = () => {
  const orderDetails = useSelector(getOrderDetails);
  const buyerIdFromCurrentOrder = useSelector(getBuyerIdFromCurrentOrder);
  const { data: homepageSlugData, isLoading: isLoadingBuyerHomePage } = useBuyerHomepage({
    buyerId: buyerIdFromCurrentOrder,
    enabled: !isEmpty(buyerIdFromCurrentOrder),
  });

  if (isLoadingBuyerHomePage) {
    return (
      <Wrapper size={WrapperSize.XLARGE}>
        <SkeletonLayout isLoading skeleton={<PageSkeleton />} />
      </Wrapper>
    );
  }

  if (isDefined(homepageSlugData?.slug)) {
    return <Navigate to={compiledPaths.PAGE_ORDER({ id: orderDetails.order.order, pageSlug: homepageSlugData.slug })} replace />;
  }

  return (
    <Navigate
      to={compiledPaths.PRODUCTS_ORDER({
        id: orderDetails.order.order,
      })}
      replace
    />
  );
};
